<template>
  <modal 
    :show.sync="isVisible" 
    size="lg" 
    :closeOnBackdrop="true"
    modalClasses="video-modal"
    @close="closeModal"
  >
    <template #header>
      <h4 class="mb-0">{{ videoTitle }}</h4>
    </template>
    
    <div class="video-wrapper">
      <iframe
        v-if="videoUrl"
        :src="videoUrlWithAutoplay"
        frameborder="0"
        allowfullscreen
        allow="autoplay; encrypted-media"
      ></iframe>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import { bus } from "@/bus";

export default {
  name: "VideoModal",
  components: {
    Modal
  },
  data() {
    return {
      isVisible: false,
      videoUrl: null,
      videoTitle: "",
    };
  },
  computed: {
    videoUrlWithAutoplay() {
      if (!this.videoUrl) return "";
      // Ensure autoplay is in the URL
      if (this.videoUrl.includes('autoplay=1')) {
        return this.videoUrl;
      }
      const separator = this.videoUrl.includes('?') ? '&' : '?';
      return `${this.videoUrl}${separator}autoplay=1`;
    }
  },
  mounted() {
    // Listen for video open events
    bus.$on('open-video-modal', this.openModal);
    bus.$on('close-video-modal', this.closeModal);
  },
  beforeDestroy() {
    // Clean up event listeners
    bus.$off('open-video-modal', this.openModal);
    bus.$off('close-video-modal', this.closeModal);
  },
  methods: {
    openModal({ videoUrl, title }) {
      this.videoUrl = videoUrl;
      this.videoTitle = title || "Video";
      this.isVisible = true;
    },
    closeModal() {
      this.isVisible = false;
      // Clear video URL after modal closes to stop playback
      setTimeout(() => {
        this.videoUrl = null;
        this.videoTitle = "";
      }, 300);
    }
  }
};
</script>

<style scoped>
.video-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.video-wrapper iframe {
  width: 100%;
  height: 500px;
  min-height: 400px;
  border: none;
}

@media (max-width: 768px) {
  .video-wrapper iframe {
    height: 300px;
    min-height: 300px;
  }
}
</style>

<style>
/* Global styles to ensure modal renders properly above all content */
.video-modal {
  z-index: 9999 !important;
}

.video-modal .modal {
  z-index: 9999 !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: auto !important;
}

.video-modal .modal-dialog {
  z-index: 10000 !important;
  position: relative !important;
  margin: 1.75rem auto !important;
}
</style>

